export default [
  { text: "Дата", value: "completeAt", type: "date", width: "12%" },
  { text: "Сумма", type: "text", value: "sum" },
  { text: "Платник", type: "text", value: "kontragentName" },
  { text: "ЄДРПОУ", type: "text", value: "kontragentEgrpou" },
  { text: "Призначення платежу", type: "text", value: "paymentPurpose" },
  { text: "", component: "TransactionTypeLabel", value: "debitCredit" },
  { text: "", component: "InfoMenu", style: "padding-right: 0", width: "35px", props: { bankName: "Таскомбанк" } },
  { text: "", component: "CreatePaymentBtn", style: "padding-left: 5px", width: "35px", props: { disabled: true } },
];